import WorkOffOutlinedIcon from "@mui/icons-material/WorkOffOutlined";
import { Box, Stack, Tooltip } from "@mui/material";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import { DataGridPro } from "@mui/x-data-grid-pro-6";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import SortedDataGridPro6 from "../../../../design/sorted-datagrid-pro-6";
import useWorkCenterColumns from "./controllers/use-workcenter-columns";
import MyChip from "./my-chip";


interface GridColumn {
    field: string;
    type?: string;
    width?: number;
    minWidth?: number;
    flex?: number;
    headerName?: string;
    renderHeader?: () => React.ReactNode;
    renderCell?: (params: { row: any }) => React.ReactNode;
    valueGetter?: (params: { row: any }) => any;
    headerAlign?: "left" | "center" | "right";
    sortable?: boolean;
    getActions?: (params: { row: any }) => any[];
    hide?: boolean
}

const useStyles = makeStyles(() => ({
    dataGridRoot: {
        border: "none",
    },
    dataGridTable: {
        border: "none",
    },
    dataGridCell: {
        border: "none",
    },
}));

const NUMBER_OF_ROWS_PER_PAGE = 5;

interface IWorkCenterTableProps {
    // workCenters: any
    setWorkCenterData: React.Dispatch<React.SetStateAction<any>>;
    currentLocationData: any;
    openDialog: () => void;
}

const WorkCenterTable: React.FC<IWorkCenterTableProps> = ({
    // workCenters,
    setWorkCenterData,
    currentLocationData,
    openDialog,
}) => {
    // const locations = useSelector(
    // 	(state) => state.gatAdminConfiguration.locations
    // );

    const classes = useStyles();
    const [pageSize, setPageSize] = useState(NUMBER_OF_ROWS_PER_PAGE);
    const getLocationsStatus = useSelector(
        (state: any) => state.gatAdminConfiguration.getLocations.status
    );
    const getLocationsErrorMessage = useSelector(
        (state: any) => state.gatAdminConfiguration.getLocations.errorMessage
    );
    const [workCenterList, setWorkCenterList] = useState<any>([]);

    const [page, setPage] = useState(0);
    const columns = useWorkCenterColumns({ openDialog, setWorkCenterData });

    // useEffect(() => {
    //     if (recentlyUpdatedLocationId !== 0) {
    //         locationsArray.forEach((location: any, index: number) => {
    //             if (parseInt(location.id) === parseInt(recentlyUpdatedLocationId)) {
    //                 setPage(Math.floor(index / NUMBER_OF_ROWS_PER_PAGE));
    //             }
    //         });
    //     }
    // }, [recentlyUpdatedLocationId, locationsArray]);

    // useEffect(() => {
    //     try {
    //         // Injecting setLocationData into data
    //         const newLocations: any = [];
    //         if (locations.length > 0) {
    //             locations.forEach((location: any) => {
    //                 newLocations.push({
    //                     ...location,
    //                     wcCount: location.workCenters.length,
    //                     changeWorkCenterData: (value: any) => setWorkCenterData(value),
    //                 });
    //             });
    //             newLocations.sort((a: any, b: any) => {
    //                 return -(a.id - b.id); // Latest id first
    //             });
    //             setLocationsArray(newLocations);
    //         } else {
    //             setLocationsArray([]);
    //         }
    //     } catch (e) {
    //         // Do nothing
    //     }
    // }, [locations, setWorkCenterData]);

    useEffect(() => {
        if (currentLocationData.workCenters && currentLocationData.workCenters.length > 0) {
            const updatedWorkCenters = currentLocationData.workCenters.map((wc: any) => {
                return {
                    ...wc,
                    locationId: currentLocationData.id,
                    companyId: currentLocationData.companyId,
                };
            });
            setWorkCenterList(updatedWorkCenters);
        } else {
            setWorkCenterList([]);
        }
    }, [currentLocationData.companyId, currentLocationData.id, currentLocationData.workcenters, currentLocationData.workCenters]);

    return (
        <Box sx={{ width: "100%" }} mt={2}>
            <SortedDataGridPro6
                getRowId={(rows: any) => rows.id}
                disableColumnMenu
                columns={columns}
                rows={workCenterList}
                loading={getLocationsStatus === "pending"}
                pagination
					initialState={{
                        ...workCenterList,
						pagination: { paginationModel: { pageSize: 5 } },
						filter: {},
					}}
					pageSizeOptions={[5, 10, 15]}
                getRowHeight={() => "auto"}
                disableRowSelectionOnClick
                sx={{
						border: "none !important",
                        height: 400,

						// "&>.MuiDataGrid-main": {
						// 	"& div div div div >.MuiDataGrid-cell": {
						// 		borderBottom: "none",
						// 	},
						// },

						"& .MuiDataGrid-row": {
							border: "none !important",
						},

						".MuiDataGrid-cell": {
							minHeight: "42px !important",
							"&:focus": {
								outline: "none",
							},
							"&.hover-column-cell": {
								position: "sticky",
								right: 24,
								zIndex: 1,
							},
							"& .hover-content": {
								transition: "opacity 0.3s ease-in-out",
								opacity: 0,
							},
						},
						".MuiDataGrid-cell:focus-within": {
							outline: "none",
						},
						"& .MuiDataGrid-columnHeader:focus-within": {
							outline: "none",
						},
						".MuiDataGrid-row:hover .hover-column-cell .hover-content": {
							opacity: 1,
							backgroundColor: "#f5f5f5",
						},
					}}
                components={{
                    NoRowsOverlay: () => (
                        <Stack height='100%' alignItems='center' justifyContent='center'>
                            <Box
                                sx={{
                                    position: "relative",
                                    height: "32px",
                                    width: "32px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <WorkOffOutlinedIcon
                                    sx={{
                                        width: "24px",
                                        height: "24px",
                                        color: "rgba(0, 0, 0, 0.38)",
                                    }}
                                />
                            </Box>
                            <Typography
                                sx={{
                                    fontFamily: "Roboto",
                                    fontSize: "14px",
                                    fontWeight: 400,
                                    color: "rgba(0, 0, 0, 0.38)",
                                    marginTop: "4px",
                                    textAlign: "center",
                                }}
                            >
                                {getLocationsErrorMessage !== ""
                                    ? "Error: " + getLocationsErrorMessage
                                    : "No Workcenter added"}
                            </Typography>
                        </Stack>
                    ),
                }}
            />
        </Box>
    );
};

export default WorkCenterTable;
